import { CpsSearchQueryRequest } from '@cs-cms/types';

export const searchKeys = {
  all: ['search'] as const,
  filteredSearch: (searchQuery?: CpsSearchQueryRequest) => [...searchKeys.all, { searchQuery }] as const
};
